import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductStockLocation } from '../../../models/ProductStock';

export const CollectionProductStockStatus: React.FC<{
    quantity: ProductStockLocation[];
}> = (props) => {
    const { quantity } = props;
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });

    const currentStock = quantity.find((elem) => elem.default);

    const sumStock = quantity.reduce(
        (partialSum, a) => partialSum + a.quantity,
        0
    );

    return (
        <Box>
            <Typography sx={{ fontWeight: 'bold', lineBreak: 'anywhere' }}>
                <span>{currentStock.location}</span>{' '}
                {currentStock ? currentStock.quantity : 0} db
            </Typography>
            <Typography sx={{ fontWeight: 'bold', lineBreak: 'anywhere' }}>
                <span>Összesen</span> {sumStock} db
            </Typography>
        </Box>
    );
};
